import type { SortOption } from '@iconik-io/shared-lib/src/utils/sort/types';

export const INITIAL_SEARCH_SORTING: SortOption[] = [
  { name: 'date_created', order: 'desc' },
];

export const INITIAL_SHARE_SORTING: SortOption[] = [
  { name: 'title', order: 'asc' },
];

export const DEFAULT_SEARCH_REQUEST_FIELDS = [
  'id',
  'title',
  'keyframes',
  'object_type',
  'type',
  'proxies',
  'files',
  'format',
  'formats',
  'permissions',
  'versions',
  'category',
  'storage_id',
  'parent_id',
  'in_collections',
  'is_blocked',
  'warning',
  'external_id',
  'external_link',
  'versions_number',
  'favoured_by',
  'metadata',
  'comments_count',
  'approval',
  'time_end_milliseconds',
  'time_start_milliseconds',
  'face_recognition_status',
  'has_unconfirmed_persons',
  'person_ids',
];

export const DEFAULT_SEARCH_FIELDS = [
  'title',
  'description',
  'segment_text',
  'file_names',
  'metadata',
];

export const DEFAULT_SEARCH_STATUS_VALUE = ['ACTIVE'];
